// src/siteInfo.js
/**
 * The details that appear in more than one piece of chrome — the contact strip
 * in the header, the footer columns, the About panel on the home page. Kept in
 * one place so a changed phone number is a one line edit and never goes stale
 * in half the places it is printed.
 *
 * Everything here is copy the site already published. Nothing is written for
 * the business; if a claim is not in here, the chrome does not make it.
 */
export const SITE = {
  name: 'Crestancia',
  address: '1 Bunsen Street, Sasolburg, 1947',
  phone: '+27 83 296 7420',
  email: 'anlivdh@crestancia.co.za',
  // The About panel's own words, now the single source for the footer too.
  about:
    'At Crestancia, we deliver premium quality farm products designed to support your agricultural needs. Our commitment to excellence means every product meets the highest standards.',
};

/** Dialling and mail links, derived so the printed values stay the source. */
export const phoneHref = `tel:${SITE.phone.replace(/[^+\d]/g, '')}`;
export const emailHref = `mailto:${SITE.email}`;
export const mapHref = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
  SITE.address,
)}`;

/**
 * The wordmark face. Fraunces is a modern take on a farm-sign serif; the stack
 * behind it is deliberate, because a blocked font request should still land on
 * a serif rather than fall back to the body sans.
 */
export const DISPLAY_FONT = "'Fraunces', 'Georgia', 'Times New Roman', serif";
